export const VERSION = '2.34.0';
